import { isLoggedIn, GdprCookie, setGdprCookie } from './cookies';

/*
 * The following code is expected to be obsolete soon, as soon as we roll out Cookiebot (or some other consent
 * management platform). It was copy/pasted from service-site-assets, and modified so that it will work with
 * the new rdp. As it was in service-site-assets wouldn't work with the new rdp, as it was dependent on legacy
 * libraries that we had no intention of bringing across.
 */

const COOKIEINFO = 'Welcome, this site uses cookies. <a href="https://www.tes.com/us/privacy-policy" style="color:white;text-decoration: underline">Read our privacy policy</a>';
const COOKIEINFO_SHORT = 'Welcome, this site uses <a href="https://www.tes.com/us/privacy-policy" style="color:white;text-decoration: underline">cookies</a>.';

const HOOK_CLASS = 'cookielaw-panel';
const PANEL_CLASSES = HOOK_CLASS + ' text-center padding-top-xs padding-bottom-xs padding-left-lg padding-right-lg';
const INFO_CLASSES = 'text--white padding-right-sm padding-left-sm';

function createPanel() {
  if (document.querySelector('.' + HOOK_CLASS)) return;
  const wrapper = document.createElement('div');
  const isSmallScreen = Boolean(document.documentElement.clientWidth < 600);
  const anchoredTo = isSmallScreen ? 'top' : 'bottom';
  wrapper.className = PANEL_CLASSES;
  wrapper.style.backgroundColor = '#0077a0';
  wrapper.style.position = isSmallScreen ? 'absolute' : 'fixed';
  wrapper.style[anchoredTo] = isSmallScreen ? '72px' : '0';
  wrapper.style.width = '100%';
  wrapper.style.zIndex = '201';
  wrapper.style.padding = '16px 0';
  wrapper.style.transition = 'transform ease-out 200ms';


  const info = document.createElement('span');
  wrapper.style.color = '#ffffff';
  info.className = INFO_CLASSES;
  info.innerHTML = isSmallScreen ? COOKIEINFO_SHORT : COOKIEINFO;
  wrapper.appendChild(info);

  const close = document.createElement('span');
  close.innerHTML = '<span class="hidden-xs"><a href="#" style="color:white;padding-left:30px;" >Close</a></span><span class="visible-xs padding-top-sm"><span style="color:white;">Close</span></span>';
  wrapper.appendChild(close);

  document.body.insertBefore(wrapper, document.body.firstChild);

  let currentBodyPadding;

  close.addEventListener('click', destroyPanel);

  function destroyPanel(evt) {
    evt.preventDefault();

    const topLevelDomain = window.location.hostname.split('.');
    topLevelDomain.shift();
    const domain  = topLevelDomain.join('.');
    setGdprCookie({ domain });

    if (isSmallScreen) {
      document.documentElement.style.paddingTop = currentBodyPadding;
      wrapper?.parentNode?.removeChild(wrapper);
    } else {
      wrapper.style.transform = 'translateY(100%)';
      setTimeout(function () {
        wrapper?.parentNode?.removeChild(wrapper);
      }, 600);
    }
  }
}

const gdpCookie = GdprCookie();
if (!gdpCookie && !isLoggedIn) {
  window.addEventListener('load', function load() {
    window.removeEventListener('load', load, false);
    createPanel();
  });
}
